module.exports = __webpack_public_path__ + "img/match5.433d5c86.png";